module.exports = __webpack_public_path__ + "static/media/webvr1.164cae84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/polidea/webvr1.jpg
// module id = 415
// module chunks = 0